import { render } from "./UpdateActivity.vue?vue&type=template&id=1fa1d4b5"
import script from "./UpdateActivity.vue?vue&type=script&lang=js"
export * from "./UpdateActivity.vue?vue&type=script&lang=js"

import exportComponent from "C:\\ProgramData\\Jenkins\\.jenkins\\workspace\\1h_web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__